import  { useQuery } from '@tanstack/react-query';
import { TtService } from '../../services/generatedApi';

const useTTNewsStartPage = () => {
    return useQuery(
        ["TTNews"],
        () => TtService.ttGetTtNewsStartpage().then((response) => response)
    );
}

export default useTTNewsStartPage